import React, { useState } from 'react';
import "animate.css"
import WeatherApp from './WeatherApp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { faHandPointLeft } from '@fortawesome/free-solid-svg-icons';
import Calculator from './Calculator';
import Riddles from './Riddles';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { faRepeat } from '@fortawesome/free-solid-svg-icons';
import Grid from './Grid';

export default function Show(){
      const [step, setStep] = useState(1)
      
    return(
        <section className='flex flex-col items-center justify-center' id='projects'>
        <div className='flex flex-row items-center w-[100%] justify-between py-[30px] sm:px-[50px] px-[20px]'>
        <button 
        onClick={() => {
            if(step > 1){
                setStep(step - 1)
            }
            if(step === 1){
                setStep(7)
            }
            
        }}
        >
        <FontAwesomeIcon icon={faHandPointLeft} style={{color: "#0c8c34", fontSize: "30px"}} />
        </button>
        
        <div
            className={`uppercase mb-[20px] rotate-[-10deg] cyborg bg-[#12141d] px-[20px] toolingBox py-[15px] text-[30px]`}>
            
                Projects
                
            </div>
            <button
            onClick={() => {
                if(step < 7){
                    setStep(step + 1)
                }
                if(step === 7){
                    setStep(1)
                }
                
            }}
            >
            <FontAwesomeIcon icon={faHandPointRight} style={{color: "#0c8c34", fontSize: "30px"}} />
            </button>
        
        </div>

        {
            step === 1 && <WeatherApp />
        }

        {
            step === 2 && <Calculator />
        }
        {
            step === 3 && <Riddles />
        }
        {
            step === 4 && <section className='bg-white-500 expoSpace w-[100%] h-[80vh] '>
            <div className='bg-[white] h-[100%] flex flex-col items-center justify-center'>
                <div className='bg-yellow-400 flex flex-col justify-between w-[250px] h-[80%] rounded-[15px] p-[20px]'>
                    <div className='bg-white h-[50px] rounded flex flex-col items-center justify-center text-[20px]'>
                        Create Note
                    </div>
                    
                    <a
                    className='bg-red-400 rounded flex flex-col items-center justify-center p-[15px]' 
                    href='https://64767eae889e5c28853bcb88--fanciful-bubblegum-ab8eed.netlify.app/' target='_blank'>
                        Click to start
                    </a>
                
                </div>

            </div>
         </section>
        }

        {
            step === 5 && <section className='bg-white-500 expoSpace w-[100%] h-[80vh] '>
            <a href='https://codepen.io/codepen-io-ibrahims/pen/bGmNjpP' target='_blank' 
            className='bg-[white] h-[100%] flex flex-col items-center justify-center'>
                <div className='bg-red-700 h-[80%] w-[250px] rounded flex flex-col items-center justify-between p-[20px] uppercase'>
                    <h1 className='bg-[#ef5350] w-[100%] rounded text-center p-[10px] text-red-700'>pomodoro clock</h1>

                    <section className='flex flex-row items-center justify-between w-[100%] text-[12px] pt-[20px]'>
                    <div className='w-[48%] flex flex-col items-center '>
                        <h1>
                            break length
                        </h1>
                        <div className='flex flex-row items-center justify-between w-[100%]'>
                            <button 
                            className='text-[20px] bg-white p-[5px] w-[15px] flex flex-col items-center justify-center text-center'
                            >
-
                            </button>
                                25:00
                            <button
                             className='text-[20px] bg-white p-[5px] w-[15px] flex flex-col items-center justify-center text-center'
                             >
+
                            </button>
                        </div>
                    </div>
                    <div className='w-[48%] flex flex-col items-center '>
                        <h1>session length</h1>
                        <div className='flex flex-row items-center justify-between w-[100%]'>
                            <button 
                            className='text-[20px] bg-white p-[5px] w-[15px] flex flex-col items-center justify-center text-center'
                            >
-
                            </button>
                                25
                            <button 
                            className='text-[20px] bg-white p-[5px] w-[15px] flex flex-col items-center justify-center text-center'
                            >
+
                            </button>
                        </div>
                    </div>
                </section>

                <section className='w-[100%] flex flex-col items-center justify-center mt-[30px] bg-[#ef5350] p-[20px] rounded-[20px]'>
                    <div>
                        Session
                    </div>

                    <div>
                        25:00
                    </div>

                    <div className='flex flex-row items-center justify-between w-[100%]'>
                        <FontAwesomeIcon icon={faPlayCircle} style={{color: "white", fontSize: "30px"}} />
                        <FontAwesomeIcon icon={faRepeat} style={{color: "white", fontSize: "30px"}} />
                        
                        
                    </div>
                </section>
                </div>


            </a>
            </section>
        }
        {
            step === 6 && 
            <section className=' expoSpace flex flex-col items-center justify-center'>
            <h1 className='text-[20px] bg-[#0f8434] w-[100%] flex flex-col items-center justify-center'>Grid</h1>

            <Grid />
            </section>
            
        }

        {
            step === 7 && 
            <section className='bg-[#10ba46] text-[white] w-[100%] border-[#333] border-solid border-[2px] flex flex-col justify-center items-center connect pt-[30px]'>
                <h1 className='connect toolingBox p-[20px] '>Other Projects/works</h1>

                <a className='text-[30px] flex flex-col w-[100%] border-[#333] border-solid border-t-[2px] px-[20px]  py-[10px] mt-[20px] text-white' href='https://rad-empanada-8e7ec9.netlify.app/' target='_blank'>
                A Clothing Brand website
                <span className='text-[10px]'>To Login: (name: "lani" password:"shoks")</span>
                </a>
                <a className='text-[30px] w-[100%] border-[#333] border-solid border-t-[2px] px-[20px]  py-[10px] text-white' href='https://jolayemiservices.com' target='_blank'>A Pest control website</a>
                <a className='text-[30px] flex flex-col w-[100%] border-[#333] border-solid border-t-[2px] px-[20px]  py-[10px] mt-[20px] text-white' 
                href='https://zap.africa/' target='_blank'>
                Crypto currency exchange webapp
                <span className='text-[10px]'>This belongs to a company i work for</span>
                </a>
                <a className='text-[30px] w-[100%] border-[#333] border-solid border-t-[2px] px-[20px]  py-[10px] text-white' href='https://heroic-parfait-66cdd6.netlify.app/' target='_blank'>Photography Portfolio</a>
                <a className='text-[30px] w-[100%] border-[#333] border-solid border-t-[2px] px-[20px]  py-[10px] text-white' href='https://guileless-florentine-d28971.netlify.app/' target='_blank'>Hackaton challenge</a>
                
            </section>
        }
        </section>
    )
}

